import style from './givingli.module.scss';
import Image from 'next/image';
import { FC, useState } from 'react';
import { InView } from 'react-intersection-observer';
import { useRouter } from 'next/router';
import Slider from './slider/slider';
import { givingliState } from './givingli.content';
import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';
import { Themes } from '@layouts/main-layout/themes.enum';
import PreviewSection from '@components/shared/preview-section/preview-section';
import GivingliEssence from './givingli-essence/givingli-essence';
import Coloboration from './coloboration/coloboration';
import OurTask from './our-tasks/our-task';
import FAQSection from '@components/shared/blocks/faq';
import TechnologyStack from './technology-stack/technology-stack';
import Greeting from './greeting/greeteng';
import QuoteSection from '@components/shared/quote-section/quote-section';
import SharedAnimation from '@components/shared/animation';
import animations from '@components/shared/animation/animations.module.scss';
import AppStore from './app-store/app-store';

interface GivingliProjectProps {
  breadcrumbsText: string;
}

const GivingliComponent: FC<GivingliProjectProps> = ({ breadcrumbsText }) => {
  const { preview, infoBlock, ourTask, faq, statistics, greeting, technologyStack, feedback, appStore } = givingliState;

  return (
    <>
      <Breadcrumbs lastElementTitle={breadcrumbsText} theme={Themes.Default} />
      <PreviewSection preview={preview} isDifferentColor={false} isCustomzePhoto={true} />
      <GivingliEssence infoBlock={infoBlock} />
      <Coloboration statistics={statistics} />
      <OurTask ourTask={ourTask} />
      <SharedAnimation
        render={(ref) => (
          <div ref={ref} className={`${style.containerDifferent} ${animations.scroll__animation}`}>
            <FAQSection title={faq.title} itemsFAQ={faq.items} hoverColor={'grey'} />
          </div>
        )}
      />
      <TechnologyStack technologyStack={technologyStack} />
      <Greeting greeting={greeting} />
      <QuoteSection section={feedback} isDifferentColor={true} />
      <AppStore appstore={appStore} />
    </>
  );
};

export default GivingliComponent;
